
export const sortCardsByDefault = (a,b) => b.default - a.default;